var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightBulbWhiteJackrabbitPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 356.62 356.62",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.31 0C79.99 0 0 79.99 0 178.311S79.99 356.62 178.31 356.62s178.31-79.989 178.31-178.31S276.63 0 178.31 0zm0 326.62C96.532 326.62 30 260.089 30 178.311S96.532 30 178.31 30s148.31 66.532 148.31 148.311S260.088 326.62 178.31 326.62z",
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31 66.949c-35.58 0-64.527 28.947-64.527 64.527 0 8.284 6.716 15 15 15s15-6.716 15-15c0-19.038 15.489-34.527 34.527-34.527s34.527 15.489 34.527 34.527-15.489 34.527-34.527 34.527c-8.284 0-15 6.716-15 15v33.915c0 8.284 6.716 15 15 15s15-6.716 15-15v-20.675c28.371-6.779 49.527-32.35 49.527-62.768 0-35.579-28.947-64.526-64.527-64.526z",
    fill: "#ffffff",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.31,
    cy: 265.899,
    r: 20.999,
    fill: "#ffffff",
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBulbWhiteJackrabbitPay);
export default __webpack_public_path__ + "static/media/icon-light-bulb-white-jackrabbit-pay.92cbcbc660099dad499abd9dbbcf3c03.svg";
export { ForwardRef as ReactComponent };